var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('div',[_c('h3',{staticClass:"m-b"},[_vm._v(_vm._s(_vm.schema.text))])]),_c('t-message-list',{attrs:{"originalMessage":_vm.message,"crossIdFilter":true,"crossType":_vm.schema.crossType,"crossId":_vm.data.id,"full":true,"read-only":_vm.schema.readOnly},on:{"input":_vm.handleTempMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }